<template>
  <div class="checked-password">
    <el-form label-width="155px">
      <el-form-item label="请输入会员消费密码：">
        <div class="password-input">
          <div v-for="(item, index) in 6" :key="index" :class="['input-box',((password.length == 0 && index == 0) ||
            (password.length == 1 && index == 1) ||
            (password.length == 2 && index == 2) ||
            (password.length == 3 && index == 3) ||
            (password.length == 4 && index == 4) ||
            (password.length == 5 && index == 5) ||
            (password.length == 6 && index == 5)) &&
            inputFocus ? 'active' : '']"
          >
            <img v-show="((password.length == 0 && index == 0) ||
              (password.length == 1 && index == 1) ||
              (password.length == 2 && index == 2) ||
              (password.length == 3 && index == 3) ||
              (password.length == 4 && index == 4) ||
              (password.length == 5 && index == 5)) &&
              inputFocus" src="../../assets/images/input.gif" class="left-img"
            />
            <!-- <img src="../assets/images/car/input.gif" class="right-img" v-show="(password.length == 6 && index == 5) && inputFocus" /> -->
            <span v-show="(password.length >= 1 && index == 0) ||
              (password.length >= 2 && index == 1) ||
              (password.length >= 3 && index == 2) ||
              (password.length >= 4 && index == 3) ||
              (password.length >= 5 && index == 4) ||
              (password.length >= 6 && index == 5)"
            ></span>
            <img v-show="password.length == 6 && index == 5 && inputFocus" src="../../assets/images/input.gif" class="right-img" />
          </div>
          <input ref="focus" v-model.trim="password" maxlength="6" :oninput="(password = $intNum(password))" @blur="inputFocus = false" @focus="inputFocus = true" />
          <el-tooltip effect="light" placement="top">
            <div slot="content">
              <p>为保证支付安全，建议接入数字小键盘，用<br>于前台消费时客户输入消费密码验证</p>
            </div>
            <i class="el-icon-warning ccinon"></i>
          </el-tooltip>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="cctr">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" :disabled="password.length == 6 ? false : true" @click="password.length == 6 ? savePassword() : ''">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { validMemberCardPayPwd } from './api';

export default {
  props: {
    memberCard: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      password: '',
      inputFocus: true
    };
  },
  mounted() {
    this.$refs.focus.focus();
  },
  methods: {
    cancel() {
      this.password = '';
      this.$emit('successPassword', '');
    },
    savePassword() {
      if (this.password.length == 6) {
        const data = {
          pwd: this.password,
          cardId: this.memberCard.cardId
        };
        validMemberCardPayPwd(data).then((res) => {
          if (res.data == 1) {
            this.$emit('successPassword', this.password);
            setTimeout(() => {
              this.password = '';
            }, 300);
          } else {
            this.password = '';
            this.$message({ type: 'error', message: '密码有误，请重试！' });
          }
        });
      } else {
        this.$message('请输入完整的密码');
      }
    }
  }
};
</script>
<style lang="less" scoped>
.password-input {
  display: flex;
  position: relative;
  .input-box {
    width: 40px;
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-right: 5px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #000;
      z-index: 8;
    }
    .left-img {
      width: 40px;
      height: 40px;
      position: absolute;
      left: -8px;
    }
    .right-img {
      width: 40px;
      height: 40px;
      position: absolute;
      right: -6px;
    }
    .right-img {
      left: 6px;
    }
  }
  .active {
    // border: 1px solid $mainColor;
  }
  input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    height: 42px;
    width: 280px;
  }
}
.cctr {
  margin: 20px 0;
  text-align: right;
}
.ccinon {
  font-size: 14px;
  color: #ccc;
  margin-left: 5px;
  line-height: 42px;
}
</style>
